import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import { LanguageContext } from '../../context';

import styles from './navigation.module.css';

function isCurrentTab(locale, frenchLink, englishLink, location = {}) {
  const link = locale === 'fr' ? frenchLink : englishLink;
  const pathname = location.pathname || '';
  if ((pathname === '/' || !pathname) && (link === '/actualites' || link === '/news')) {
    return true;
  }
  console.log({ pathname, link });
  return pathname.startsWith(link);
}

function getCorrectTranslation(locale, french, english) {
  return locale === 'fr' ? french : english;
}

const Navigation = ({ location }) => {
  const locale = useContext(LanguageContext);
  return (
    <nav role="navigation" className={styles.nav}>
      <ul className={styles.navigation}>
        <li
          className={`${styles.navigationItem} ${
            isCurrentTab(locale, '/actualites', '/news', location) ? styles.currentTab : ''
          }`}
        >
          <Link to={`/${getCorrectTranslation(locale, 'actualites', 'news')}`}>
            {getCorrectTranslation(locale, 'Actualités', 'News')}
          </Link>
        </li>
        <li>-</li>
        <li
          className={`${styles.navigationItem} ${
            isCurrentTab(locale, '/projets', '/projects', location) ? styles.currentTab : ''
          }`}
        >
          <Link to={`/${getCorrectTranslation(locale, 'projets', 'projects')}`}>
            {getCorrectTranslation(locale, 'Projets', 'Projects')}
          </Link>
        </li>
        <li>-</li>
        <li
          className={`${styles.navigationItem} ${
            isCurrentTab(locale, '/agence', '/agency', location) ? styles.currentTab : ''
          }`}
        >
          <Link to={`/${getCorrectTranslation(locale, 'agence', 'agency')}`}>
            {getCorrectTranslation(locale, 'Agence', 'Agency')}
          </Link>
        </li>
        <li>-</li>
        <li
          className={`${styles.navigationItem} ${
            isCurrentTab(locale, '/contact', '/contact-us', location) ? styles.currentTab : ''
          }`}
        >
          <Link to={`/${getCorrectTranslation(locale, 'contact', 'contact-us')}`}>Contact</Link>
        </li>
      </ul>
    </nav>
  );
};
Navigation.propTypes = {
  location: PropTypes.object,
};
Navigation.defaultProps = {
  location: {},
};

export default Navigation;
